import { render, staticRenderFns } from "./ExpireAlert.vue?vue&type=template&id=3df9d5ba"
import script from "./ExpireAlert.vue?vue&type=script&lang=js"
export * from "./ExpireAlert.vue?vue&type=script&lang=js"
import style0 from "./ExpireAlert.vue?vue&type=style&index=0&id=3df9d5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports